import JSEncrypt from "jsencrypt";
import vars from "../vars";

const encrypt = (text: string): string => {
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(vars.publicKey)
  const encrypted = encrypt.encrypt(text);
  return encrypted?.toString();
}

export default encrypt;